import { RouteList } from '.';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HashRouter, Route, Routes } from 'react-router-dom';


function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        const scrollContainer = document.getElementById("main");
        if (scrollContainer)
            scrollContainer?.scrollTo({ top: 0, behavior: "auto" });
        else
            window.scrollTo({ top: 0, behavior: "auto" });
    }, [pathname]);

    return null;
}



export default function Router() {
    return (
        <HashRouter>
            <ScrollToTop />
            <Routes>
                {
                    RouteList().map((route, index) => (
                        <Route
                            key={index}
                            path={route.path}
                            element={
                                <route.layout>
                                    {route.component()}
                                </route.layout>
                            }
                        />
                    ))
                }
            </Routes>
        </HashRouter>
    )
}